import { Directive, HostListener, Input } from '@angular/core';

import { DCLAnalyticsService } from '../services/analytics/analytics.service';
import { TrackLinkConstants } from './track-link-constants';

@Directive({
    selector: '[dclTrackLink]'
})
export class TrackLinkDirective {
    @Input() dclTrackLink: string;
    @Input() modelProps: object;
    @Input() enableInnerClicksTrack = false;
    constructor(private analyticsService: DCLAnalyticsService) { }

    @HostListener('click', ['$event.target'])
    onClick(event?: HTMLElement) {
        if (!this.enableInnerClicksTrack) {
            this.analyticsService.trackLink(this.dclTrackLink, this.modelProps);
        } else {
            this.captureInnerAnchorClicks(event);
        }
    }

    captureInnerAnchorClicks(event: HTMLElement): void {
        if (event.tagName.toLowerCase() === TrackLinkConstants.ANCHOR_TAG) {
            this.analyticsService.trackLink(this.dclTrackLink, this.modelProps);
        }
    }
}
